const contractEditorRoute = {
  path: '',
  component: () => import('@/views/uspqrp/contract-editor/Wrapper.vue'),
  children: [
    {
      path: '/uspqrp/contract-editor',
      name: 'contractEditorMain',
      component: () => import('@/views/uspqrp/contract-editor/Main.vue'),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.rempro.uspqrp.contracteditor'],
        },
      },
    },
    {
      path:
        '/uspqrp/contract-editor/management/:academicYearId/:contractTypeId/:versionId?',
      name: 'contractEditorManagement',
      component: () =>
        import('@/views/uspqrp/contract-editor/ContractEditorManagement.vue'),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.rempro.uspqrp.contracteditor'],
        },
      },
    },
  ],
};
export default contractEditorRoute;
